// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class DeliveryOption extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Options = {
    Genesis: 1,
    CPU: 2,
    UPS: 3,
    TBD: 4,
    DPU: 5,
};
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  acknowledgementRequired!: boolean;
  dealerAcknowledgementMessage?: string;
  dealerConfirmationMessage?: string;
  dealerOption!: boolean;
  deleted?: Date;
  description?: string;
  displayOrder?: number;
  mapIcon?: string;
  name?: string;
  note?: string;
  requiresFreight!: boolean;
}

